import {
  FETCH_BONUSES_CONTENT_REQUEST,
  FETCH_BONUSES_CONTENT_FAIL,
  FETCH_BONUSES_CONTENT_SUCCESS,
} from '../../constants/bonuses';
import { actionCreator } from '../../helpers';

// CMS Content
export const fetchBonusesContentRequest = actionCreator(
  FETCH_BONUSES_CONTENT_REQUEST
);
export const fetchBonusesContentFail = actionCreator(
  FETCH_BONUSES_CONTENT_FAIL
);
export const fetchBonusesContentSuccess = actionCreator(
  FETCH_BONUSES_CONTENT_SUCCESS
);
